"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const logisticMonitoringsTaskTripsService = {
  getLogisticMonitoringsTaskTrips: function (options) {
    return api.get("/LogisticMonitorings/TaskTrips", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  getLogisticMonitoringsTaskTrip: function (options) {
    return api.get("/LogisticMonitorings/TaskTrips/" + options.id, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  completedLogisticTaskTrip: function (options) {
    return api.put(`/LogisticMonitorings/TaskTrips/${options.id}/Completed`, {}, WithToken.headersToken({}, configuration.cookieName));
  },
  addUnitLogisticTaskTrip: function (options) {
    return api.post(`/LogisticMonitorings/TaskTrips/${options.id}/Unit`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  addRoutesLogisticTaskTrip: function (options) {
    return api.post(`/LogisticMonitorings/TaskTrips/${options.id}/Routes`, options, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default logisticMonitoringsTaskTripsService;
